import React, { Component } from 'react';
import './App.css';
import { dataLoggerSchema, siteSchema } from '../normalize';
import { normalize } from 'normalizr';
import { apiBase, requestHeaders } from '../index';
import { connect } from 'react-redux';
import {
  setGroupingFilter,
  setGroupingFilterRelations
} from '../actions/grouping';
import { setSite } from '../actions/site';
import { setSensors } from '../actions/sensors';
import { setLoggers } from '../actions/loggers';
import moment from 'moment-timezone';
import SiteHeader from '../components/SiteHeader';
import SiteFooter from '../components/SiteFooter';
import SiteHeaderBreadCrumbNav from '../components/SiteHeaderBreadCrumbNav';
import {
  setAppContainerWidth,
  setAppError,
  setAppTimezone
} from '../actions/app';
import { setAppLoading } from '../actions/loading';
import { withStyles } from 'material-ui/styles';
import classNames from 'classnames';
import { styles } from '../styles/App';
import { requestToken } from '../auth';

const fetchSitesAndLoggers = async ({
  siteId,
  setSite,
  setAppTimezone,
  setGroupingFilterRelations,
  setLoggers,
  setSensors
}) => {
  const promises = [
    fetch(`${apiBase}/sites/${siteId}`, { headers: requestHeaders }),
    fetch(`${apiBase}/data_loggers?filter[site]=${siteId}`, {
      headers: requestHeaders
    })
  ];

  try {
    const results = await Promise.all(promises);

    if (results.reduce((redirect, next) => next.status === 401, false)) {
      requestToken();
    }

    const site = await normalize((await results[0].json()).data, siteSchema);
    const loggers = await normalize((await results[1].json()).data, [
      dataLoggerSchema
    ]);

    await setSite(site.entities.sites[siteId]);
    await setLoggers(loggers.entities.loggers);
    await setSensors(loggers.entities.sensors);
    await setGroupingFilterRelations({
      area_room: loggers.entities.area_room,
      area_functional: loggers.entities.area_functional,
      building_floor: loggers.entities.building_floor,
      equipment_type: loggers.entities.equipment_type,
      equipment_group: loggers.entities.equipment_group,
      type: loggers.entities.types
    });

    const timezone = await site.entities.sites[siteId].timezone;
    await moment.tz.setDefault(timezone);
    await setAppTimezone(timezone);

    return {};
  } catch (err) {
    console.log('App.js', err);
    return { error: 'API error, please check your siteId' };
  }
};

class App extends Component {
  constructor(props) {
    super(props);
    this.updateDimensions = this.updateDimensions.bind(this);
  }

  updateDimensions() {
    const containerWidth = this.refs.contentContainer.offsetWidth;

    if (this.props.appWidth === containerWidth) {
      return;
    }

    // todo: set timeout?
    this.props.setAppContainerWidth(containerWidth);
  }

  async componentWillMount() {
    const {
      siteId,
      setSite,
      setLoggers,
      setSensors,
      setGroupingFilterRelations,
      setAppTimezone,
      setAppLoading,
      setAppError,
      site
    } = this.props;

    if (!siteId) {
      setAppError('No site id found!');
      return;
    }

    if (site !== null) {
      return;
    }

    if (site && site.id === siteId) {
      return;
    }

    setAppLoading(true);

    const resp = await fetchSitesAndLoggers({
      siteId,
      setSite,
      setAppTimezone,
      setLoggers,
      setSensors,
      setGroupingFilterRelations,
      setAppError
    });

    if (await resp.error) {
      setAppError(resp.error);
      setAppLoading(false);
    } else {
      setAppLoading(false);
    }
  }

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  render() {
    const {
      children,
      match,
      site,
      external,
      errors,
      classes,
      timezone,
      loading
    } = this.props;

    const showHeader = external !== true;
    const showFooter = external !== true;

    const breadCrumbs = {
      site,
      match
    };

    const appClass = external
      ? classNames(classes.app, classes.appDark)
      : classes.app;

    if (errors && errors.length > 0) {
      return (
        <div className={appClass}>
          <SiteHeader show={showHeader} timezone={timezone} loading={loading} />
          <div className="app__content">
            <div className="container">
              {errors.map((error, index) => <div key={index}>{error}</div>)}
            </div>
          </div>
          <SiteFooter show={showFooter} />
        </div>
      );
    }

    return (
      <div className={appClass}>
        <SiteHeader show={showHeader} timezone={timezone} loading={loading} />
        <SiteHeaderBreadCrumbNav show={showHeader} links={breadCrumbs} />

        <div className={classes.app__content}>
          <div ref="contentContainer" className="container">
            {site && timezone ? { ...children } : <div>...Loading App</div>}
          </div>
        </div>
        <SiteFooter show={showFooter} />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  appWidth: state.app.appWidth,
  loading: state.loading,
  timezone: state.app.timezone,
  errors: state.app.errors,
  groupFilter: state.groupFilter,
  site: state.site,
  match: ownProps.match
});

export default connect(mapStateToProps, {
  setAppLoading,
  setAppTimezone,
  setAppError,
  setAppContainerWidth,
  setGroupingFilter,
  setSite,
  setLoggers,
  setSensors,
  setGroupingFilterRelations
})(withStyles(styles, { name: 'App' })(App));



// WEBPACK FOOTER //
// ./src/container/App.js